module.exports = __webpack_public_path__ + "static/media/300x209 Simpel 1.a496258c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/component/img/device/300x209 Simpel 1.svg
// module id = 973
// module chunks = 2